import { Check, ChevronsUpDown, Building2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../components/ui/dropdown-menu";
import { useCompany } from "../context/CompanyContext";

export function CompanySwitcher() {
  const { companies, active, activeId, switchCompany, switching } = useCompany();
  if (!active) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button data-testid="company-switcher-trigger" variant="outline"
          className="h-9 max-w-[220px] sm:max-w-[300px] justify-start gap-2 border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900">
          <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-[10px] font-bold text-white"
            style={{ background: active.accent || "#0F172A" }}>
            {(active.code || "KG").slice(0, 2)}
          </span>
          <span className="truncate text-sm font-medium">{active.name}</span>
          <ChevronsUpDown className="h-3.5 w-3.5 shrink-0 text-slate-400" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[320px] bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-slate-500">
          Krishna Group — Switch Company
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {companies.map((c) => (
          <DropdownMenuItem key={c.company_id} data-testid={`company-option-${c.code.toLowerCase()}`}
            disabled={switching}
            onClick={() => switchCompany(c.company_id)}
            className="flex items-center gap-2.5 cursor-pointer py-2.5">
            <span className="flex h-7 w-7 items-center justify-center rounded-md text-[10px] font-bold text-white"
              style={{ background: c.accent || "#0F172A" }}>
              {c.code.slice(0, 2)}
            </span>
            <span className="flex-1">
              <span className="block text-sm font-medium leading-tight">{c.name}</span>
              <span className="block text-[11px] text-slate-500 capitalize">{c.role?.replace(/_/g, " ")}</span>
            </span>
            {c.company_id === activeId && <Check className="h-4 w-4 text-emerald-600" />}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <div className="px-2 py-1.5 flex items-center gap-1.5 text-[11px] text-slate-400">
          <Building2 className="h-3 w-3" /> Data is fully isolated per company
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
